<template>
    <div>
        <SecondFA v-if="verifySuccess" 
                  :user="user" />
        <Verify v-else
                v-on:success="handleSuccess" />
    </div>
</template>
<script>
    import Verify from "./Verify.vue";
    import SecondFA from "./2FA.vue";

    export default {
        components: {
            Verify,
            SecondFA,
        },
        data() {
            return {
                verifySuccess: false,
                user: {},
            }
        },
        methods: {
            handleSuccess(payload) {
                this.user = payload;
                this.verifySuccess = true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Components/Auth/Login.vue